import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./WorkDetails_Complaint.css";
import moment from "moment";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";

export default function WorkDetails_Complaint({
  complaintDetails,
  setcomplaintDetails,
  isSubmitting,
  handleSubmit,
}) {
  const locate = useLocation();
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const createdDate = complaintDetails.createdDate; // ISO string from backend
  const daysAgo = moment().diff(moment(createdDate), "days");
  const [workDetails, setWorkDetails] = useState();

  const formatDatecreate = (isoDate) => {
    const date = new Date(isoDate);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };
  // Helper function to format work time
  const formatWorkTime = (minutes) => {
    if (!minutes) return "-";
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return (
      `${hours > 0 ? `${hours} Hour${hours !== 1 ? "s" : ""}` : ""} ${
        mins > 0 ? `${mins} Minute${mins !== 1 ? "s" : ""}` : ""
      }`.trim() || "-"
    );
  };
  // Helper function to format date
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB"); // DD/MM/YYYY format
  };
  useEffect(() => {
    axios
      .get(`${apiUrl}workdetails/${complaintDetails._id}`)
      .then((res) => {
        setWorkDetails(res.data);
      })
      .catch((error) => {
        console.error("Error fetching work details:", error);
      });
  }, [complaintDetails._id, apiUrl]);
  useEffect(() => {
    axios
      .post(apiUrl + "get-complaint", {
        id: locate.state?.id,
      })
      .then((res) => {
        setcomplaintDetails(res.data.message);
        // Store original data for comparison
      });
  }, [locate.state?.id]);
  return (
    <div>
      <Container>
        <form>
          <div className="plan-details-container-border-complaint mt-5 text-center ms-5">
            <p style={{ fontSize: "13px" }} className="mt-3">
              {/* <span className='text-primary'>Network</span> */}
              Complaint -{" "}
              <span className="text-primary">
                {complaintDetails?.complaintType}
              </span>{" "}
              Customer Affected -{" "}
              <span className="text-primary">
                {complaintDetails?.complaintcustomerAffected} @{" "}
              </span>
              Location -{" "}
              <span className="text-primary">
                {complaintDetails?.complaintlocation}
              </span>
            </p>
            <p style={{ fontSize: "13px" }} class="mb-3">
              {" "}
              Complaint Open Date -{" "}
              <span className="text-primary">
                {formatDatecreate(complaintDetails.createdDate)} ,{" "}
              </span>{" "}
              Complaint Open Last -{" "}
              <span className="text-primary">{daysAgo} Days</span>
            </p>
          </div>

          <table className="table table-bordered mt-5">
            <thead className="table-th text-center">
              <tr>
                <th>Staff Name</th>
                <th>Bike Type</th>
                <th>KM Travel</th>
                <th>Cable Used</th>
                <th>Work Time</th>
              </tr>
            </thead>
            <tbody>
              {workDetails?.length > 0 ? (
                workDetails.map((work) => (
                  <tr key={work._id} className="text-center">
                    <td>{work.staffName || "-"}</td>
                    <td>{work.bikeType || "-"}</td>
                    <td>
                      {work.kmTraveled !== null && work.kmTraveled !== undefined
                        ? `${work.kmTraveled} KM`
                        : "-"}
                    </td>
                    <td>
                      {work.cableUsed !== null && work.cableUsed !== undefined
                        ? `${work.cableUsed} KM`
                        : "-"}
                    </td>
                    <td>{formatWorkTime(work.workTime)}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="text-center">
                    No data found
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          {/* <div className="mt-5 mb-5 fiber-team-upload-photo">
            <label>
              <strong>Photos</strong>
            </label>
            <div className="fiber-team-photos mt-3 mb-4">
              <Row className="mt-3">
                <Col className="text-center">
                  <div className="ms-4">
                    <p>
                      <strong>Cable</strong>
                    </p>
                    <img
                      src=""
                      width="150px"
                      height="130px"
                      style={{ borderRadius: "5px" }}
                    />
                    <p style={{ fontSize: "11px" }} className="mt-2">
                      By Saravanan <span className="ms-4">12/12/2024</span>
                    </p>
                  </div>
                </Col>
                <Col className="text-center">
                  <div className="ms-4">
                    <p>
                      <strong>Splicing</strong>
                    </p>
                    <img
                      src="https://www.fujikura.co.uk/netalogue/news/Fibre%20Optic%20Splicing%20Explained.jpg"
                      width="150px"
                      height="130px"
                      style={{ borderRadius: "5px" }}
                    />
                    <p style={{ fontSize: "11px" }} className="mt-2">
                      By Saravanan <span className="ms-4">12/12/2024</span>
                    </p>
                  </div>
                </Col>
                <Col className="text-center">
                  <div className="ms-4">
                    <p>
                      <strong>Power Meter</strong>
                    </p>
                    <img
                      src=""
                      width="150px"
                      height="130px"
                      style={{ borderRadius: "5px" }}
                    />
                    <p style={{ fontSize: "11px" }} className="mt-2">
                      By Saravanan <span className="ms-4">12/12/2024</span>
                    </p>
                  </div>
                </Col>
                <Col className="text-center">
                  <div className="ms-4">
                    <p>
                      <strong>Other</strong>
                    </p>
                    <img
                      src=""
                      width="150px"
                      height="130px"
                      style={{ borderRadius: "5px" }}
                    />
                    <p style={{ fontSize: "11px" }} className="mt-2">
                      By Saravanan <span className="ms-4">12/12/2024</span>
                    </p>
                  </div>
                </Col>
              </Row>
            </div>

            <label>
              <strong>Network Team Photos</strong>
            </label>

            <div className="fiber-team-photos mt-3 mb-4">
              <Row className="mt-3">
                <Col className="text-center">
                  <div className="ms-4">
                    <p>
                      <strong>Router Sticker</strong>
                    </p>
                    <img
                      src=""
                      width="150px"
                      height="130px"
                      style={{ borderRadius: "5px" }}
                    />
                    <p style={{ fontSize: "11px" }} className="mt-2">
                      By Saravanan <span className="ms-4">12/12/2024</span>
                    </p>
                  </div>
                </Col>
                <Col className="text-center">
                  <div className="ms-4">
                    <p>
                      <strong>Speed Test</strong>
                    </p>
                    <img
                      src="https://www.fujikura.co.uk/netalogue/news/Fibre%20Optic%20Splicing%20Explained.jpg"
                      width="150px"
                      height="130px"
                      style={{ borderRadius: "5px" }}
                    />
                    <p style={{ fontSize: "11px" }} className="mt-2">
                      By Saravanan <span className="ms-4">12/12/2024</span>
                    </p>
                  </div>
                </Col>
                <Col className="text-center">
                  <div className="ms-4">
                    <p>
                      <strong>Review</strong>
                    </p>
                    <img
                      src=""
                      width="150px"
                      height="130px"
                      style={{ borderRadius: "5px" }}
                    />
                    <p style={{ fontSize: "11px" }} className="mt-2">
                      By Saravanan <span className="ms-4">12/12/2024</span>
                    </p>
                  </div>
                </Col>
              </Row>
            </div>

            <label>
              <strong>Updateds Photos</strong>
            </label>

            <div className="fiber-team-photos mt-3 mb-4">
              <Row className="mt-3">
                <Col className="text-center">
                  <div className="ms-4">
                    <p>
                      <strong>Cable</strong>
                    </p>
                    <img
                      src=""
                      width="150px"
                      height="130px"
                      style={{ borderRadius: "5px" }}
                    />
                    <p style={{ fontSize: "11px" }} className="mt-2">
                      By Saravanan <span className="ms-4">12/12/2024</span>
                    </p>
                  </div>
                </Col>
              </Row>
            </div>
          </div> */}
    <div className="mt-5 mb-5 complaint-photo-section">
  <label>
    <strong>Complaint Photos</strong>
  </label>

  <div className="complaint-photo-container mt-3 mb-4">
    <Row className="mt-3">
      {complaintDetails?.workDetails?.photos?.length > 0 ? (
        complaintDetails.workDetails.photos.map((photo) => (
          <Col className="text-center" key={photo._id} xs={6} md={3}>
            <div className="complaint-photo-box">
             
              <img
                src={photo.image}
                className="complaint-photo-img"
                alt={photo.subtype || "Work photo"}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src =
                    "https://placehold.co/150x130?text=No+Image";
                }}
              />
              <p className="complaint-photo-footer mt-2">
                By {photo.staffName}
                <span className="ms-4">{formatDate(photo.date)}</span>
              </p>
            </div>
          </Col>
        ))
      ) : (
        <Col className="text-center">
          <p className="text-muted">No photos available</p>
        </Col>
      )}
    </Row>
  </div>
</div>


        </form>
      </Container>
    </div>
  );
}
